var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from "./component";
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(args) {
        var _this = _super.call(this, args) || this;
        _this.onHidden = function () {
            _this.element.addEventListener('hidden.bs.modal', function () {
                if (document.querySelector('#cerberus-modal'))
                    document.querySelector('#cerberus-modal').remove();
            });
        };
        _this.hide = function () {
            _this.componentInstance.hide();
        };
        _this.addCloseEvent = function () {
            var _a;
            (_a = _this.element.querySelector('.modal-btn-close')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                console.log('close');
                _this.componentInstance.hide();
            });
        };
        _this.show = function () {
            var _a;
            _this.setElement();
            _this.setComponentInstance();
            // this.append();
            _this.attachEventListeners();
            _this.addCloseEvent();
            _this.onHidden();
            _this.componentInstance.show();
            (_a = document.querySelector('.modal-backdrop')) === null || _a === void 0 ? void 0 : _a.classList.add('cerberus');
        };
        _this.name = 'modal';
        _this.composer = args === null || args === void 0 ? void 0 : args.composer;
        return _this;
    }
    ;
    return Modal;
}(Component));
export { Modal };
;
